import { BobPaint } from "./BobPaint";
import design from "./bob-design.json";

/** The same six soft curves render in the wordmark, activity and concern markers. */
export function BobWaveShapes({ id, fill }: { readonly id: string; readonly fill?: string }) {
  return (
    <>
      {!fill && <BobPaint id={id} />}
      <defs>
        <mask
          id={`${id}-seams`}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="100"
          height="100"
          style={{ forcedColorAdjust: "none" }}
        >
          <circle cx="50" cy="50" r="48" fill="white" />
          <g fill="none" stroke="black" strokeWidth={design.seamWidth} strokeLinecap="round">
            {design.seams.map((path) => (
              <path key={path} d={path} />
            ))}
          </g>
        </mask>
      </defs>
      <g mask={`url(#${id}-seams)`}>
        {design.bands.map((path) => (
          <g key={path} className="bob-wave-band">
            <path className="bob-wave-face" d={path} fill={fill ?? `url(#${id}-light)`} />
            {!fill && (
              <path
                className="bob-wave-rim"
                d={path}
                fill="none"
                stroke={`url(#${id}-rim)`}
                strokeWidth="0.45"
              />
            )}
          </g>
        ))}
      </g>
    </>
  );
}
